import {useCallback, useDebugValue, useState} from 'react';

export function useSubmitHandler(handler) {
    const [isSubmitting, setSubmitting] = useState(false);
    useDebugValue(isSubmitting);

    const submitHandler = useCallback((event) => {
        event.preventDefault();
        if (!isSubmitting) {
            setSubmitting(true);
            handler(event).finally(() => {
                setSubmitting(false);
            });
        }
    }, [isSubmitting, handler]);

    return [isSubmitting, submitHandler];
}
